module.exports = __webpack_public_path__ + "media/usecase_enterprise_05.fbd1303f.mp4";